module.exports = __webpack_public_path__ + "static/media/Mask Group 176.50c61bf0.svg";